import AbstractService from "./Abstract.service";

export default class SettingService extends AbstractService
{
    listing(): Promise<any>
    {
        return this.post(`/notify`);
    }

    getting(payload:Object): Promise<any>
    {
        return this.post(`/notify/get`,payload);
    }

    creating(payload:Object): Promise<any>
    {
        return this.post(`/notify/create`,payload);
    }

    updating(payload:Object): Promise<any>
    {
        return this.post(`/notify/update`,payload);
    }

    deleting(payload:Object): Promise<any>
    {
        return this.post(`/notify/delete`,payload);
    }
}